// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  CreateBackupJobAnnotationData,
  CreateBackupJobAnnotationErrors,
  CreateBackupJobAnnotationResponses,
  GetAiCapacityData,
  GetAiCapacityResponses,
  GetAiEstateData,
  GetAiEstateResponses,
  GetAiMcpHealthData,
  GetAiMcpHealthResponses,
  GetAiOverviewData,
  GetAiOverviewResponses,
  GetAiSpendData,
  GetAiSpendResponses,
  GetBackupActionsData,
  GetBackupActionsResponses,
  GetBackupCoverageData,
  GetBackupCoverageResponses,
  GetBackupJobAnnotationsData,
  GetBackupJobAnnotationsErrors,
  GetBackupJobAnnotationsResponses,
  GetBackupJobRunsData,
  GetBackupJobRunsErrors,
  GetBackupJobRunsResponses,
  GetBackupJobsData,
  GetBackupJobsErrors,
  GetBackupJobsResponses,
  GetBackupOverviewData,
  GetBackupOverviewResponses,
  GetBackupSitesData,
  GetBackupSitesErrors,
  GetBackupSitesResponses,
  GetBackupSlaComplianceData,
  GetBackupSlaComplianceErrors,
  GetBackupSlaComplianceResponses,
  GetClaudeOverviewData,
  GetClaudeOverviewResponses,
  GetCloudAdvisorData,
  GetCloudAdvisorResponses,
  GetCloudAlertsData,
  GetCloudAlertsResponses,
  GetCloudChangesData,
  GetCloudChangesResponses,
  GetCloudComplianceData,
  GetCloudComplianceResponses,
  GetCloudCostData,
  GetCloudCostResponses,
  GetCloudGovernanceData,
  GetCloudGovernanceResponses,
  GetCloudOverviewData,
  GetCloudOverviewResponses,
  GetCloudServiceHealthData,
  GetCloudServiceHealthResponses,
  GetCloudWorkloadsData,
  GetCloudWorkloadsResponses,
  GetCopilotOverviewData,
  GetCopilotOverviewResponses,
  GetDefenderAlertsData,
  GetDefenderAlertsResponses,
  GetDefenderIdentityHealthData,
  GetDefenderIdentityHealthResponses,
  GetDefenderIncidentsData,
  GetDefenderIncidentsResponses,
  GetDefenderPermissionsData,
  GetDefenderPermissionsResponses,
  GetDefenderSecureScoreData,
  GetDefenderSecureScoreResponses,
  GetFoConsoleAuditData,
  GetFoConsoleAuditErrors,
  GetFoConsoleAuditResponses,
  GetFoConsoleCollectStatusData,
  GetFoConsoleCollectStatusResponses,
  GetFoConsoleDeviceData,
  GetFoConsoleDeviceErrors,
  GetFoConsoleDeviceResponses,
  GetFoConsoleExperienceData,
  GetFoConsoleExperienceErrors,
  GetFoConsoleExperienceResponses,
  GetFoConsoleFindingData,
  GetFoConsoleFindingErrors,
  GetFoConsoleFindingResponses,
  GetFoConsolePinpointData,
  GetFoConsolePinpointErrors,
  GetFoConsolePinpointResponses,
  GetFoConsolePlatformData,
  GetFoConsolePlatformErrors,
  GetFoConsolePlatformResponses,
  GetFoConsoleRecordData,
  GetFoConsoleRecordErrors,
  GetFoConsoleRecordResponses,
  GetFoConsoleReportData,
  GetFoConsoleReportErrors,
  GetFoConsoleReportResponses,
  GetFoConsoleRumMeData,
  GetFoConsoleRumMeResponses,
  GetFoConsoleRumStatusData,
  GetFoConsoleRumStatusResponses,
  GetFoConsoleSlowSummaryData,
  GetFoConsoleSlowSummaryErrors,
  GetFoConsoleSlowSummaryResponses,
  GetFoConsoleUserData,
  GetFoConsoleUserErrors,
  GetFoConsoleUserResponses,
  GetFoIntegrationData,
  GetFoIntegrationResponses,
  GetFoOverviewData,
  GetFoOverviewResponses,
  GetFoRequestsData,
  GetFoRequestsResponses,
  GetFoUserExperienceData,
  GetFoUserExperienceResponses,
  GetHealthData,
  GetHealthResponses,
  GetLicenseOverviewData,
  GetLicenseOverviewResponses,
  GetLicenseSkusData,
  GetLicenseSkusResponses,
  GetLicenseWasteData,
  GetLicenseWasteResponses,
  GetM365IncidentsData,
  GetM365IncidentsResponses,
  GetM365MessagesData,
  GetM365MessagesResponses,
  GetM365ServiceHealthData,
  GetM365ServiceHealthResponses,
  GetMeData,
  GetMeResponses,
  GetMonitoringHistoryData,
  GetMonitoringHistoryErrors,
  GetMonitoringHistoryResponses,
  GetMonitoringOverviewData,
  GetMonitoringOverviewResponses,
  GetNetworkLinksData,
  GetNetworkLinksResponses,
  GetNetworkOverviewData,
  GetNetworkOverviewResponses,
  GetNetworkSitesData,
  GetNetworkSitesResponses,
  GetReclaimableAccountsData,
  GetReclaimableAccountsResponses,
  GetSecurityCampaignsData,
  GetSecurityCampaignsResponses,
  GetSecurityHistoryData,
  GetSecurityHistoryErrors,
  GetSecurityHistoryResponses,
  GetSecurityOverviewData,
  GetSecurityOverviewResponses,
  GetSecurityTargetedPeopleData,
  GetSecurityTargetedPeopleResponses,
  IngestAzureAlertData,
  IngestAzureAlertResponses,
  IngestBackupReportData,
  IngestBackupReportResponses,
  ListFoConsoleReportsData,
  ListFoConsoleReportsErrors,
  ListFoConsoleReportsResponses,
  LogoutData,
  LogoutResponses,
  PostFoConsoleReportData,
  PostFoConsoleReportErrors,
  PostFoConsoleReportResponses,
  PostFoConsoleRumData,
  PostFoConsoleRumErrors,
  PostFoConsoleRumResponses,
  RefreshCloudData,
  RefreshCloudResponses,
  RefreshMonitoringData,
  RefreshMonitoringResponses,
  RunFoConsoleCollectData,
  RunFoConsoleCollectErrors,
  RunFoConsoleCollectResponses,
  SearchFoConsoleUsersData,
  SearchFoConsoleUsersErrors,
  SearchFoConsoleUsersResponses,
  UpdateFoConsoleReportData,
  UpdateFoConsoleReportErrors,
  UpdateFoConsoleReportResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * M365 Service Health
 *
 * Return the current health of every Microsoft 365 service.
 *
 * Served from a TTL cache over Microsoft Graph, so a page load costs at most
 * one upstream call per cache window and Graph's throttling never reaches the
 * browser.
 */
export const getM365ServiceHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetM365ServiceHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetM365ServiceHealthResponses, unknown, ThrowOnError>({
    url: "/m365/service-health",
    ...options,
  });

/**
 * M365 Incidents
 *
 * Return open service-health issues plus those resolved in the last 7 days.
 *
 * Derived from the same cached snapshot as `/m365/service-health`, so the two
 * views can never disagree about what is currently broken.
 */
export const getM365Incidents = <ThrowOnError extends boolean = false>(
  options?: Options<GetM365IncidentsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetM365IncidentsResponses, unknown, ThrowOnError>({
    url: "/m365/incidents",
    ...options,
  });

/**
 * M365 Messages
 *
 * Return Message Center posts — announced changes and planned maintenance.
 *
 * Derived from the same cached snapshot as `/m365/service-health`. When Graph
 * refuses the read, `messages_available` is false and `missing_scopes` names
 * the permission — the list is empty either way, and the two states are told
 * apart by the envelope rather than by an empty array.
 */
export const getM365Messages = <ThrowOnError extends boolean = false>(
  options?: Options<GetM365MessagesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetM365MessagesResponses, unknown, ThrowOnError>({
    url: "/m365/messages",
    ...options,
  });

/**
 * License Overview
 *
 * Return the licence board's headline: totals, waste, and renewal risk.
 *
 * Aggregates only — nothing here identifies a person.
 */
export const getLicenseOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetLicenseOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetLicenseOverviewResponses, unknown, ThrowOnError>({
    url: "/licenses/overview",
    ...options,
  });

/**
 * License Skus
 *
 * Return every subscribed SKU, including the ones excluded from totals.
 *
 * Excluded SKUs are returned rather than dropped, each with its
 * `excluded_reason`, so the board can show its working: a total nobody can
 * reconcile is a total nobody trusts.
 */
export const getLicenseSkus = <ThrowOnError extends boolean = false>(
  options?: Options<GetLicenseSkusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetLicenseSkusResponses, unknown, ThrowOnError>({
    url: "/licenses/skus",
    ...options,
  });

/**
 * License Waste
 *
 * Return the waste view: unused seats, grace-period exposure, dead SKUs.
 *
 * Aggregates only.
 */
export const getLicenseWaste = <ThrowOnError extends boolean = false>(
  options?: Options<GetLicenseWasteData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetLicenseWasteResponses, unknown, ThrowOnError>({
    url: "/licenses/waste",
    ...options,
  });

/**
 * Reclaimable Accounts
 *
 * Return reclaim candidates — identities for admins, counts for everyone else.
 *
 * This is the one endpoint on the board that can return employee personal
 * data, so the role check happens here. A non-admin is not refused: they get
 * the same aggregate counts the rest of the board shows, `admin: false`, and
 * an empty `accounts` list. Refusing outright would push callers toward
 * scraping the numbers from elsewhere; returning aggregates keeps the useful
 * part available without exposing who they refer to.
 */
export const getReclaimableAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<GetReclaimableAccountsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetReclaimableAccountsResponses, unknown, ThrowOnError>({
    url: "/licenses/reclaimable-accounts",
    ...options,
  });

/**
 * Network Overview
 *
 * Return the SASE estate: config state, rollup, sites and recent events.
 *
 * Served from the TTL-cached snapshot, so a page load costs no Cato calls —
 * `accountMetrics` allows only 15 a minute for the whole account, which makes
 * per-request fetching impossible rather than merely wasteful.
 */
export const getNetworkOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetNetworkOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetNetworkOverviewResponses, unknown, ThrowOnError>({
    url: "/network/overview",
    ...options,
  });

/**
 * Network Sites
 *
 * Return every Cato site with its Sockets, WAN ports and metrics.
 */
export const getNetworkSites = <ThrowOnError extends boolean = false>(
  options?: Options<GetNetworkSitesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetNetworkSitesResponses, unknown, ThrowOnError>({
    url: "/network/sites",
    ...options,
  });

/**
 * Network Links
 *
 * Return every last-mile WAN port in the estate, flattened for the matrix.
 *
 * One row per physical port, carrying the ISP behind it
 * (`tunnelRemoteIPInfo.provider`), tunnel uptime and the last reconnect reason.
 */
export const getNetworkLinks = <ThrowOnError extends boolean = false>(
  options?: Options<GetNetworkLinksData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetNetworkLinksResponses, unknown, ThrowOnError>({
    url: "/network/links",
    ...options,
  });

/**
 * Cloud Overview
 *
 * Return the Azure estate rollup: subscriptions, resources, and side panels.
 *
 * Served from a TTL cache, so a dashboard refresh is a memory read unless the
 * snapshot has aged out. Reconciles what Azure Resource Graph returned against
 * the expected subscription list, so an unreadable subscription is reported
 * rather than silently shrinking the estate.
 */
export const getCloudOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudOverviewResponses, unknown, ThrowOnError>({
    url: "/cloud/overview",
    ...options,
  });

/**
 * Cloud Workloads
 *
 * Return every workload in the estate with its live status.
 *
 * Container apps, app services, PostgreSQL flexible servers, and virtual
 * machines — all from one Resource Graph query, including VM power state.
 */
export const getCloudWorkloads = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudWorkloadsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudWorkloadsResponses, unknown, ThrowOnError>({
    url: "/cloud/workloads",
    ...options,
  });

/**
 * Cloud Service Health
 *
 * Return Azure's own service health events for NOVA's subscriptions.
 *
 * An empty `events` list with a `checked_at` timestamp is the healthy answer,
 * not a missing one.
 */
export const getCloudServiceHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudServiceHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudServiceHealthResponses, unknown, ThrowOnError>({
    url: "/cloud/service-health",
    ...options,
  });

/**
 * Cloud Advisor
 *
 * Return Azure Advisor's posture: counts by category and impact, plus the top items.
 */
export const getCloudAdvisor = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudAdvisorData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudAdvisorResponses, unknown, ThrowOnError>({
    url: "/cloud/advisor",
    ...options,
  });

/**
 * Cloud Alerts
 *
 * Return fired Azure Monitor alerts: everything active plus resolved ≤ 7 days.
 *
 * Estate-wide from one Resource Graph query — actual alerts, not rule counts.
 */
export const getCloudAlerts = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudAlertsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudAlertsResponses, unknown, ThrowOnError>({
    url: "/cloud/alerts",
    ...options,
  });

/**
 * Cloud Changes
 *
 * Return the change feed: who changed what, estate-wide, last 24 hours.
 */
export const getCloudChanges = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudChangesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudChangesResponses, unknown, ThrowOnError>({
    url: "/cloud/changes",
    ...options,
  });

/**
 * Cloud Compliance
 *
 * Return governance posture per subscription: policy compliance and secure score.
 */
export const getCloudCompliance = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudComplianceData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudComplianceResponses, unknown, ThrowOnError>({
    url: "/cloud/compliance",
    ...options,
  });

/**
 * Cloud Governance
 *
 * Return governance posture per subscription with day-over-day deltas.
 *
 * Same current values as `/cloud/compliance`, plus movement against the most
 * recent earlier day in the persisted history — None (unknown) until the
 * poller has written at least one prior day.
 */
export const getCloudGovernance = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudGovernanceData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudGovernanceResponses, unknown, ThrowOnError>({
    url: "/cloud/governance",
    ...options,
  });

/**
 * Cloud Cost
 *
 * Return Azure spend: month-to-date per subscription, forecast, 30-day trend.
 *
 * Served entirely from the persisted cost history — a request never queries
 * the Cost Management API; the poller's cost sweep does, at most once per
 * subscription per day.
 */
export const getCloudCost = <ThrowOnError extends boolean = false>(
  options?: Options<GetCloudCostData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCloudCostResponses, unknown, ThrowOnError>({
    url: "/cloud/cost",
    ...options,
  });

/**
 * Cloud Refresh
 *
 * Trigger an immediate poll tick (resource health, alerts, estate, changes).
 *
 * Backs the board's "Check now" button. Rate-limited: a request landing less
 * than a minute after the last tick is acknowledged without hitting Azure.
 */
export const refreshCloud = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshCloudData, ThrowOnError>,
) =>
  (options?.client ?? client).post<RefreshCloudResponses, unknown, ThrowOnError>({
    url: "/cloud/refresh",
    ...options,
  });

/**
 * Fo Overview
 *
 * Return the F&O front-office rollup: KPIs, availability trend, environments.
 *
 * Availability comes from synthetic probe results in 5-minute bins over the
 * last 24 hours; a bin with no runs is absent rather than zero, so the trend
 * shows a gap instead of a fabricated outage. Served from a TTL cache, so a
 * dashboard refresh is a memory read unless the snapshot has aged out.
 */
export const getFoOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoOverviewResponses, unknown, ThrowOnError>({
    url: "/fo/overview",
    ...options,
  });

/**
 * Fo User Experience
 *
 * Return form performance: worst forms by P95, P95 trend, distribution, load by hour.
 *
 * Forms used by fewer than five distinct users are folded into one unlabelled
 * `Other` row and the fold is reported in `suppression` — this board ranks
 * forms, never people.
 */
export const getFoUserExperience = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoUserExperienceData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoUserExperienceResponses, unknown, ThrowOnError>({
    url: "/fo/user-experience",
    ...options,
  });

/**
 * Fo Requests
 *
 * Return request health: result codes, failed dependencies, app-vs-SQL split.
 *
 * Dependencies are identified by type and target only. SQL statement text is
 * never returned: a statement embeds the literal data values it ran against.
 */
export const getFoRequests = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoRequestsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoRequestsResponses, unknown, ThrowOnError>({
    url: "/fo/requests",
    ...options,
  });

/**
 * Fo Integration
 *
 * Return Service Bus queue health from the integration Log Analytics workspace.
 *
 * A *different* workspace in a different subscription from the other three
 * routes, so it reports its access state independently. Expect
 * `access_state="workspace_not_found"` until the resource ID inherited from the
 * Power BI model is corrected — that is a configuration fault the payload
 * states outright, not an empty chart.
 */
export const getFoIntegration = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoIntegrationData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoIntegrationResponses, unknown, ThrowOnError>({
    url: "/fo/integration",
    ...options,
  });

/**
 * Slow Summary
 *
 * The aggregate strip: totals, shares, hourly trend, worst forms and sites.
 *
 * No identities. Form × entity cohorts under five distinct users are folded
 * into one `Other` row and the fold is reported in `suppression`. Served
 * from a two-minute cache per lookback.
 */
export const getFoConsoleSlowSummary = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsoleSlowSummaryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFoConsoleSlowSummaryResponses,
    GetFoConsoleSlowSummaryErrors,
    ThrowOnError
  >({ url: "/fo/console/slow-summary", ...options });

/**
 * Pinpoint
 *
 * What to fix, in what order, and what it costs — ranked, not just listed.
 *
 * Each finding names a form and, where the problem is one company's, that
 * company: `company_form` (slow here, fine in its peers), `form_all` (slow
 * everywhere, so a form-level defect), `regression` (fine one window ago) and
 * `aos_node` (one AOS instance worse than the farm, and legitimately empty on
 * a healthy day). Ranked by `excess_hours` — person-hours of waiting above
 * what the same form costs elsewhere — never by the ratio, because a 17x
 * outlier eight people hit costs less than a 3x one on a form five hundred
 * people open.
 *
 * No identities: forms, company codes and counts only. It sits behind the
 * investigator gate all the same, because a ranked list of which company is
 * worst is an operational judgement about named parts of the business, not a
 * board figure. Served from a five-minute cache per lookback.
 *
 * `company_name` comes from `NOVA_FO_COMPANY_NAMES` and falls back to the
 * code, never to a guess. A query that failed is named in `errors` and its
 * contribution is absent rather than zero.
 */
export const getFoConsolePinpoint = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsolePinpointData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFoConsolePinpointResponses,
    GetFoConsolePinpointErrors,
    ThrowOnError
  >({ url: "/fo/console/pinpoint", ...options });

/**
 * Finding
 *
 * One board row opened up: the cell's own distribution, its peers', and its hours.
 *
 * Four measurements a ranked row cannot carry. The **p10** is the one the
 * panel exists for — it separates a form that is slow for everybody (the
 * fastest tenth still costs half a minute) from a form that is fast for most
 * people and catastrophic for a few, and those are different tickets. Beside
 * it: the same percentiles pooled across every other company, a dot per
 * company so the *shape* of the disagreement is visible rather than a ratio,
 * and the median by hour of day, which is what says whether the form is slow
 * because the system is busy or because it does too much work.
 *
 * On demand and per finding — deliberately not part of `/pinpoint`, because
 * four queries per row across a 25-row board is a hundred queries for a board
 * nobody has clicked yet.
 *
 * `form` and `company` are the finding's own, as the board hands them back. A
 * value whose shape this estate does not produce is refused with 400 rather
 * than repaired: no identities are involved either way, this is the one place
 * a request value reaches a query string. Investigators only (403), like the
 * board it drills into. Served from a five-minute cache per cell and lookback.
 *
 * A form with too few loads in this company has `distribution: null` — not a
 * box of zeroes. A query that failed is named in `errors` and its block is
 * null while the rest of the drawer still renders.
 */
export const getFoConsoleFinding = <ThrowOnError extends boolean = false>(
  options: Options<GetFoConsoleFindingData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFoConsoleFindingResponses,
    GetFoConsoleFindingErrors,
    ThrowOnError
  >({ url: "/fo/console/finding", ...options });

/**
 * Search
 *
 * Find a person by alias, mail prefix or display-name token prefix.
 *
 * Answers from the cached candidate list — the people the identity job
 * resolved to exactly one Entra user — and never more than ten. Searching
 * writes no audit row; opening a person does. Investigators only (403).
 */
export const searchFoConsoleUsers = <ThrowOnError extends boolean = false>(
  options?: Options<SearchFoConsoleUsersData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    SearchFoConsoleUsersResponses,
    SearchFoConsoleUsersErrors,
    ThrowOnError
  >({ url: "/fo/console/search", ...options });

/**
 * User
 *
 * One person's last hours: timeline, exceptions, network path, slow records.
 *
 * `mail` must be a candidate's mail (404 otherwise — unknown alias, or a
 * shared or system account, which never get a per-user view). `reason` is
 * required (a ticket or report id, 400 when shorter than four characters)
 * and is written to the audit trail together with the viewer **before** the
 * workspace is queried. Computed on demand; nothing is stored (D7).
 */
export const getFoConsoleUser = <ThrowOnError extends boolean = false>(
  options: Options<GetFoConsoleUserData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetFoConsoleUserResponses, GetFoConsoleUserErrors, ThrowOnError>({
    url: "/fo/console/user",
    ...options,
  });

/**
 * Record
 *
 * One Slow-Interaction record by activity id, with its next diagnostic.
 *
 * The id must be a GUID (400 otherwise). The lookup is audited with the
 * subject it resolved to; a record that matches nothing still leaves a row.
 * `next_diagnostic` carries the Performance Timer URL pre-filled with the
 * record's legal entity and form, and the Help → Trace capture checklist.
 */
export const getFoConsoleRecord = <ThrowOnError extends boolean = false>(
  options: Options<GetFoConsoleRecordData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFoConsoleRecordResponses,
    GetFoConsoleRecordErrors,
    ThrowOnError
  >({ url: "/fo/console/record", ...options });

/**
 * Device
 *
 * The machines Defender has seen this person signed in on, and what they are.
 *
 * The static facts the browser cannot report — model, vendor, OS build, join
 * type, onboarding status, last seen — from one fixed Defender advanced-hunting
 * query over `DeviceInfo`. Gated and audited exactly like `/user`: `mail` must
 * be a candidate's mail (404 otherwise), `reason` is required (400 under four
 * characters), and the audit row naming viewer and subject is written **before**
 * Defender is asked. Nothing is stored (D7).
 *
 * A Defender-side refusal is a state, not an error: no credential renders
 * `configured=false`, and a missing `ThreatHunting.Read.All` renders
 * `access_state="unauthorised"` with the permission named in `status_detail`.
 * An empty `devices` list in the `ok` state is a real answer — an unmanaged or
 * never-onboarded machine leaves no row.
 */
export const getFoConsoleDevice = <ThrowOnError extends boolean = false>(
  options: Options<GetFoConsoleDeviceData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFoConsoleDeviceResponses,
    GetFoConsoleDeviceErrors,
    ThrowOnError
  >({ url: "/fo/console/device", ...options });

/**
 * Rum Post
 *
 * Take one batch of the extension's own browser telemetry and forward it.
 *
 * The caller's proven mail is the row's `Mail` — from an Entra ID token, or
 * from the session cookie during the rollout — and the body carries no
 * identity at all. A record whose host no app in `NOVA_RUM_APPS` lists is
 * dropped and counted in `rejected`, never a 400 for the batch — and the app a
 * row is filed under is decided from that map, not from the body. 401 for a
 * token that does not verify, 413 over 120 records or 64 KB, 429 past six
 * batches a minute per poster, 400 for a non-GUID `install_id`, 503 while the
 * intake is off or has no DCR.
 */
export const postFoConsoleRum = <ThrowOnError extends boolean = false>(
  options: Options<PostFoConsoleRumData, ThrowOnError>,
) =>
  (options.client ?? client).post<PostFoConsoleRumResponses, PostFoConsoleRumErrors, ThrowOnError>({
    url: "/fo/console/rum",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Rum Status
 *
 * Is the intake configured and on, how many posted in 24 h, and the fleet coverage.
 *
 * Counts are null — not zero — when the workspace did not answer. Served
 * from a one-minute cache.
 */
export const getFoConsoleRumStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsoleRumStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoConsoleRumStatusResponses, unknown, ThrowOnError>({
    url: "/fo/console/rum/status",
    ...options,
  });

/**
 * Rum Me
 *
 * The caller's own last seven days, beside the medians of their site cohort.
 *
 * Own data: keyed by the session mail, so there is no `mail` parameter to
 * pass, no reason to give and no audit row to write. The peer block is null
 * below the k-anonymity floor — "not enough peers", never medians of four
 * people. Open to every signed-in user; the extension's options page reads it.
 */
export const getFoConsoleRumMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsoleRumMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoConsoleRumMeResponses, unknown, ThrowOnError>({
    url: "/fo/console/rum/me",
    ...options,
  });

/**
 * Experience
 *
 * Browser-measured experience per app: latency, interactions, errors, HTTP/3, probes.
 *
 * An aggregate, so no identities and no investigator gate. Page keys used by
 * fewer than five people lose their label and are counted in `suppression`.
 * Coverage exists for F&O only — it is the one app with a fleet denominator.
 */
export const getFoConsoleExperience = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsoleExperienceData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFoConsoleExperienceResponses,
    GetFoConsoleExperienceErrors,
    ThrowOnError
  >({ url: "/fo/console/experience", ...options });

/**
 * Platform
 *
 * What the platform was doing while people used it — batch, and the front door.
 *
 * Two things this console has never shown. **Batch**: 97 % of the
 * environment's exceptions come from batch jobs rather than from anybody's
 * screen, and `AppExceptions` has always carried the job caption, the class,
 * the method and the X++ call stack. A job failing steadily hour after hour —
 * 928 an hour, unchanged at three in the morning — is a retry loop nobody
 * notices precisely because it never spikes.
 *
 * **The front door**: Microsoft's own synthetic tests have been hitting this
 * environment from a dozen Azure locations every few minutes for as long as it
 * has existed, and nothing was reading them. Put beside the hours users
 * suffered, they settle whether the network path and the front door were part
 * of it. They are URL pings that follow redirects and never sign in, so they
 * prove nothing about the application tier — which the panel says in its own
 * words rather than leaving to be inferred.
 *
 * Investigator-gated like the rest: it names batch jobs and companies, which
 * is an operational picture of the business rather than a board figure.
 */
export const getFoConsolePlatform = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsolePlatformData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFoConsolePlatformResponses,
    GetFoConsolePlatformErrors,
    ThrowOnError
  >({ url: "/fo/console/platform", ...options });

/**
 * Report List
 *
 * The reports in the window, newest first, optionally one status only.
 *
 * Names submitters, so it sits behind the investigator gate — but the list
 * reads nobody's telemetry, so it needs no reason and writes no audit row.
 * Opening one report does both.
 */
export const listFoConsoleReports = <ThrowOnError extends boolean = false>(
  options?: Options<ListFoConsoleReportsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    ListFoConsoleReportsResponses,
    ListFoConsoleReportsErrors,
    ThrowOnError
  >({ url: "/fo/console/reports", ...options });

/**
 * Report Create
 *
 * Take one "this app is slow right now" report and match it on the spot.
 *
 * The submitter is the caller's proven identity — an Entra ID token from the
 * extension's popup, or a session cookie — never the body. Open to every
 * employee, not just to NOVA users: this is a person's own report about their
 * own experience, and the click is the consent that lets NOVA keep it with
 * their mail. 401 for a token that does not verify, 503 when the report could
 * not be stored — the popup must not show an id that does not exist.
 *
 * The public address the report arrived from is read off the request rather
 * than asked of the browser: a page cannot see its own egress IP without
 * calling a third party, and NOVA already has it. It says which office,
 * breakout or ISP the person was on, which is the network fact Cato cannot
 * give us for the users it does not see. Captured here only — never on the
 * per-minute telemetry, which is collected continuously and without a click.
 */
export const postFoConsoleReport = <ThrowOnError extends boolean = false>(
  options: Options<PostFoConsoleReportData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    PostFoConsoleReportResponses,
    PostFoConsoleReportErrors,
    ThrowOnError
  >({
    url: "/fo/console/reports",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Report Detail
 *
 * One report with the form loads it matched and the function's records for them.
 *
 * A per-user view in every sense: `reason` is required (400 under four
 * characters) and the audit row naming viewer and submitter is written
 * **before** the workspace is read. 404 for an unknown id, 503 when the
 * report store cannot be read.
 */
export const getFoConsoleReport = <ThrowOnError extends boolean = false>(
  options: Options<GetFoConsoleReportData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetFoConsoleReportResponses,
    GetFoConsoleReportErrors,
    ThrowOnError
  >({ url: "/fo/console/reports/{report_id}", ...options });

/**
 * Report Update
 *
 * Move one report through triage: `new` → `triaged` → `closed`.
 *
 * Investigators only. Triage state is not a per-user *read*, so no reason and
 * no audit row; the answer is the updated list row. 404 for an unknown id.
 */
export const updateFoConsoleReport = <ThrowOnError extends boolean = false>(
  options: Options<UpdateFoConsoleReportData, ThrowOnError>,
) =>
  (options.client ?? client).patch<
    UpdateFoConsoleReportResponses,
    UpdateFoConsoleReportErrors,
    ThrowOnError
  >({
    url: "/fo/console/reports/{report_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Audit
 *
 * The most recent per-user lookups: who looked at whom, why, through which route.
 *
 * Names viewers and subjects, so it sits behind the investigator gate like the views it records.
 */
export const getFoConsoleAudit = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsoleAuditData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetFoConsoleAuditResponses,
    GetFoConsoleAuditErrors,
    ThrowOnError
  >({ url: "/fo/console/audit", ...options });

/**
 * Collect Status
 *
 * The state of the two collectors: configured, enabled, last run, watermark, last error.
 */
export const getFoConsoleCollectStatus = <ThrowOnError extends boolean = false>(
  options?: Options<GetFoConsoleCollectStatusData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetFoConsoleCollectStatusResponses, unknown, ThrowOnError>({
    url: "/fo/console/collect/status",
    ...options,
  });

/**
 * Collect Run
 *
 * Run one collector now, single-flighted like the background tick.
 *
 * `triggered` says whether it ran; it is false while another run is in
 * progress on this or another replica, or when the task is disabled.
 */
export const runFoConsoleCollect = <ThrowOnError extends boolean = false>(
  options: Options<RunFoConsoleCollectData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    RunFoConsoleCollectResponses,
    RunFoConsoleCollectErrors,
    ThrowOnError
  >({ url: "/fo/console/collect/run", ...options });

/**
 * Defender Permissions
 *
 * Return the setup panel: what this board needs, has, and never asks for.
 *
 * Makes no Graph call, so it answers with no credential and cannot be
 * throttled. This is the panel the board renders while it is dark: it names
 * each required application permission, the TODO 2.5 row it came from, and
 * whether a read has actually proved it granted, denied or never tried. It also
 * lists what is deliberately excluded — including
 * `AiEnterpriseInteraction.Read.All`, which returns employees' Copilot prompt
 * content and is out of scope permanently.
 */
export const getDefenderPermissions = <ThrowOnError extends boolean = false>(
  options?: Options<GetDefenderPermissionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDefenderPermissionsResponses, unknown, ThrowOnError>({
    url: "/defender/permissions",
    ...options,
  });

/**
 * Defender Incidents
 *
 * Return open incidents by severity, age band and daily trend.
 *
 * Counts and mixes only: no incident display name, assignee or evidence, and no
 * drill-down to one — a Defender incident title routinely contains a device or
 * account name. Detection-shaped breakdowns (classification, product) clear a
 * k>=5 floor before they are labelled; severity, status and age do not, because
 * a single high-severity incident is exactly what an operator must see.
 */
export const getDefenderIncidents = <ThrowOnError extends boolean = false>(
  options?: Options<GetDefenderIncidentsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDefenderIncidentsResponses, unknown, ThrowOnError>({
    url: "/defender/incidents",
    ...options,
  });

/**
 * Defender Alerts
 *
 * Return alert volume and its mix by product, detection source and technique.
 *
 * Alert titles are never returned: a title is a sentence Defender composed
 * about a person or a device.
 */
export const getDefenderAlerts = <ThrowOnError extends boolean = false>(
  options?: Options<GetDefenderAlertsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDefenderAlertsResponses, unknown, ThrowOnError>({
    url: "/defender/alerts",
    ...options,
  });

/**
 * Defender Secure Score
 *
 * Return Microsoft Secure Score, its daily trend and the worst open controls.
 *
 * The only Defender figure with real history behind it — Microsoft keeps daily
 * scores — so it charts as a genuine trend rather than a today-figure. A day
 * with no snapshot renders as a gap, never as a drop to zero.
 */
export const getDefenderSecureScore = <ThrowOnError extends boolean = false>(
  options?: Options<GetDefenderSecureScoreData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDefenderSecureScoreResponses, unknown, ThrowOnError>({
    url: "/defender/secure-score",
    ...options,
  });

/**
 * Defender Identity Health
 *
 * Return Defender-for-Identity sensor and agent health as counts.
 *
 * Sensors are named to Microsoft by DNS name — a domain controller's identity —
 * so this panel reports how many sensors are in each state and never which. If
 * MDI is not deployed, expect `access_state="not_provisioned"` rather than a
 * healthy-looking set of zeroes.
 */
export const getDefenderIdentityHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetDefenderIdentityHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetDefenderIdentityHealthResponses, unknown, ThrowOnError>({
    url: "/defender/identity-health",
    ...options,
  });

/**
 * Ai Overview
 *
 * Return the AI estate rollup: KPI strip, composition, and what to look at.
 *
 * The KPI strip leads on quota exhaustion and the HTTP 429 rate rather than the
 * resource census, because those are the numbers that are currently wrong in
 * the estate and nobody was told. `summary.accounts_with_zero_tokens` counts
 * accounts *measured* at zero; `summary.accounts_usage_unreadable` counts the
 * ones nothing is known about, and the two are never added together.
 */
export const getAiOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAiOverviewResponses, unknown, ThrowOnError>({
    url: "/ai/overview",
    ...options,
  });

/**
 * Ai Estate
 *
 * Return every discovered AI service account — the drill-down from the overview.
 *
 * Accounts are discovered by resource *type* and their `kind` is read as a
 * string, so an account provisioned after this shipped appears here with no
 * code change. Accounts the registry has seen that discovery no longer returns
 * are included with `presence="missing"`: a resource that disappears is a
 * finding, not an absence.
 */
export const getAiEstate = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiEstateData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAiEstateResponses, unknown, ThrowOnError>({
    url: "/ai/estate",
    ...options,
  });

/**
 * Ai Capacity
 *
 * Return quota headroom per deployment and the per-account throttling rate.
 *
 * Quota rows are de-duplicated across regions before they get here:
 * `GlobalStandard` / `DataZoneStandard` quota is subscription-wide but the
 * per-location endpoint repeats it under every region, and summing the copies
 * would multiply the limit and make an exhausted quota look comfortable. Each
 * row states its `scope` and how many region endpoints echoed it.
 */
export const getAiCapacity = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiCapacityData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAiCapacityResponses, unknown, ThrowOnError>({
    url: "/ai/capacity",
    ...options,
  });

/**
 * Ai Mcp Health
 *
 * Return MCP server fleet health, discovered rather than enumerated.
 *
 * MCP is not an Azure resource type, so hosts are discovered by type (App
 * Services and Container Apps) and classified by tag or configured name
 * pattern; `summary.candidates_considered` reports the pool that was examined,
 * so a classification matching nothing cannot render as an empty, healthy
 * fleet. ARM's control-plane state and the HTTP probe verdict are reported
 * separately and never collapsed — an unreachable server is not a healthy zero.
 */
export const getAiMcpHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiMcpHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAiMcpHealthResponses, unknown, ThrowOnError>({
    url: "/ai/mcp",
    ...options,
  });

/**
 * Ai Spend
 *
 * Return month-to-date spend on the discovered AI estate, by meter and account.
 *
 * Meter categories are **discovered by grouping**, never filtered by name: AI
 * moved from the `Azure OpenAI` meter to `Foundry Models` / `Foundry Tools`, so
 * a name filter returns zero spend — wrong in the flattering direction. This
 * route has a much longer TTL than the others because Cost Management is
 * throttled tenant-wide on Query Processing Units.
 */
export const getAiSpend = <ThrowOnError extends boolean = false>(
  options?: Options<GetAiSpendData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetAiSpendResponses, unknown, ThrowOnError>({
    url: "/ai/spend",
    ...options,
  });

/**
 * Copilot Overview
 *
 * Return org-level Microsoft 365 Copilot adoption: enabled vs active, trend, per app.
 *
 * Served from a TTL cache over the Graph beta report functions, so a page
 * load costs at most one upstream read per cache window. "Enabled" is
 * Microsoft's word for a user licensed for Copilot; a licensed-but-idle gap
 * is the finding this section exists to surface. Counts only — no per-user
 * report is ever requested, and a refused read arrives as
 * `access_state="consent_missing"`, never as zero enabled users.
 */
export const getCopilotOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetCopilotOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetCopilotOverviewResponses, unknown, ThrowOnError>({
    url: "/copilot/overview",
    ...options,
  });

/**
 * Security Overview
 *
 * Return the Security board in one payload.
 *
 * Carries the headline metrics, the 90-day dangerous-mail trend, the mail-flow
 * availability signal, the cohort breakdown, the VAP trend, the classification
 * mix, the campaign timeline, the quarter snapshot, and — beside the headline —
 * the pinned definition of "dangerous email", so the number can be defended the
 * first time someone asks what it counts.
 *
 * Aggregates only. Names are on `/security/targeted-people`.
 */
export const getSecurityOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetSecurityOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSecurityOverviewResponses, unknown, ThrowOnError>({
    url: "/security/overview",
    ...options,
  });

/**
 * Security History
 *
 * Return the day-series over an explicit window, straight from the store.
 *
 * Raises:
 * HTTPException: 422 when `days` falls outside 1..`MAX_HISTORY_DAYS`. This
 * is the one route on the board that rejects its input, because a
 * window nobody retained data for is a caller mistake rather than an
 * upstream condition — every other failure mode answers 200 with
 * `configured` and `status_detail` instead.
 */
export const getSecurityHistory = <ThrowOnError extends boolean = false>(
  options?: Options<GetSecurityHistoryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetSecurityHistoryResponses,
    GetSecurityHistoryErrors,
    ThrowOnError
  >({ url: "/security/history", ...options });

/**
 * Security Campaigns
 *
 * Return the attributed campaigns behind the board's attribution line.
 *
 * Actors, malware families and volume. Campaign data describes attackers
 * rather than employees, so it needs no role check.
 */
export const getSecurityCampaigns = <ThrowOnError extends boolean = false>(
  options?: Options<GetSecurityCampaignsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSecurityCampaignsResponses, unknown, ThrowOnError>({
    url: "/security/campaigns",
    ...options,
  });

/**
 * Security Targeted People
 *
 * Return the Very Attacked People — names for admins, counts for everyone else.
 *
 * The one endpoint on this board that can return employee personal data, so
 * the role check happens here. A non-admin is not refused: they get the same
 * aggregate figures the rest of the board shows, `admin: false`, an empty
 * `people` list and a `withheld_reason`. Refusing outright would push callers
 * toward reconstructing the list somewhere with no audit trail; returning the
 * aggregates keeps the useful part available without exposing who they are.
 *
 * Names are held for `IDENTITY_RETENTION_DAYS` (90) and purged on every write.
 * This is Timo Fahlenbock's decision of 2026-08-20: the security team cannot
 * protect an individually targeted person without knowing who they are.
 */
export const getSecurityTargetedPeople = <ThrowOnError extends boolean = false>(
  options?: Options<GetSecurityTargetedPeopleData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetSecurityTargetedPeopleResponses, unknown, ThrowOnError>({
    url: "/security/targeted-people",
    ...options,
  });

/**
 * Claude Overview
 *
 * Return the Claude usage panel: tokens, cost and Claude Code org totals.
 *
 * While `ANTHROPIC_ADMIN_KEY` is absent this answers `no_credential` with
 * copy naming exactly what unlocks it, and makes no outbound request. When
 * the key lands, the same route lights up on the next TTL expiry with no
 * code change.
 */
export const getClaudeOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetClaudeOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetClaudeOverviewResponses, unknown, ThrowOnError>({
    url: "/claude/overview",
    ...options,
  });

/**
 * Ingest Azure Alert
 *
 * Ingest one Azure Monitor Common Alert Schema delivery into `alert_event`.
 *
 * Validates the delivery's Entra JWT (signature / issuer / audience / appid /
 * expiry), parses the essentials, and upserts the alert keyed on
 * `essentials.alertId` with `source='webhook'`.
 */
export const ingestAzureAlert = <ThrowOnError extends boolean = false>(
  options?: Options<IngestAzureAlertData, ThrowOnError>,
) =>
  (options?.client ?? client).post<IngestAzureAlertResponses, unknown, ThrowOnError>({
    url: "/webhooks/azure-alerts",
    ...options,
  });

/**
 * Ingest Backup Report
 *
 * Ingest one report from the on-prem Veeam collector.
 *
 * Implements `collector/PAYLOAD.md` exactly. Idempotent on
 * `(source, job name, last_start)`: the collector's 15-minute cadence
 * re-sends the same session repeatedly and must never duplicate a run row.
 *
 * One malformed job row does not reject the report — what parses is stored
 * and the rest comes back in `errors[]`.
 */
export const ingestBackupReport = <ThrowOnError extends boolean = false>(
  options?: Options<IngestBackupReportData, ThrowOnError>,
) =>
  (options?.client ?? client).post<IngestBackupReportResponses, unknown, ThrowOnError>({
    url: "/backup/ingest",
    ...options,
  });

/**
 * Backup Overview
 *
 * Return the L0 numbers: succeeded, failed, did-not-run, oldest restore point.
 *
 * Plus collector liveness: when no source has reported inside twice its
 * expected cadence, `stale` is true and the tiles must read as unknown rather
 * than green.
 */
export const getBackupOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackupOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBackupOverviewResponses, unknown, ThrowOnError>({
    url: "/backup/overview",
    ...options,
  });

/**
 * Backup Jobs
 *
 * Return current job state across both sources, filtered.
 */
export const getBackupJobs = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackupJobsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBackupJobsResponses, GetBackupJobsErrors, ThrowOnError>({
    url: "/backup/jobs",
    ...options,
  });

/**
 * Backup Sites
 *
 * Return per-site, per-day status for the heat strip.
 *
 * Every day in the window gets a cell, including days with no runs — a site
 * that quietly stopped reporting has to be visible, not absent.
 */
export const getBackupSites = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackupSitesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBackupSitesResponses, GetBackupSitesErrors, ThrowOnError>({
    url: "/backup/sites",
    ...options,
  });

/**
 * Backup Actions
 *
 * Return every open finding on this board as one ranked list of tasks.
 *
 * The board's other endpoints each answer a question about the estate. This
 * one answers a question about the operator: *what do I have to do today?* —
 * which the old routine answered in one Veeam query and the board had spread
 * across seven panels.
 *
 * Nothing is measured here that is not already measured elsewhere: it composes
 * `overview`, `jobs`, `coverage` and `sla`, so a row can never disagree with
 * the panel it links to. Each action carries the route and search params that
 * show its evidence, so the list is a set of doors rather than a summary.
 */
export const getBackupActions = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackupActionsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBackupActionsResponses, unknown, ThrowOnError>({
    url: "/backup/actions",
    ...options,
  });

/**
 * Backup Sla Compliance
 *
 * Return the rolling success rate per site and per SLA tier.
 *
 * The question the current-status SLA panel cannot answer — "are we meeting
 * 98% over the last thirty days" — and one Azure cannot answer either, since
 * Resource Graph keeps about fourteen days of job history. It is served
 * entirely from the run history NOVA already persists, so it costs no call to
 * anything.
 *
 * Restore operations are excluded from the maths: Azure reports them through
 * the same job feed as backups, and a failed restore test is not a failed
 * backup.
 */
export const getBackupSlaCompliance = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackupSlaComplianceData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetBackupSlaComplianceResponses,
    GetBackupSlaComplianceErrors,
    ThrowOnError
  >({ url: "/backup/sla", ...options });

/**
 * Backup Job Runs
 *
 * Return one job's run history with its acknowledgements attached (L2).
 */
export const getBackupJobRuns = <ThrowOnError extends boolean = false>(
  options: Options<GetBackupJobRunsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetBackupJobRunsResponses, GetBackupJobRunsErrors, ThrowOnError>({
    url: "/backup/jobs/{name}/runs",
    ...options,
  });

/**
 * Backup Job Annotations
 *
 * Return every acknowledgement recorded against one job.
 */
export const getBackupJobAnnotations = <ThrowOnError extends boolean = false>(
  options: Options<GetBackupJobAnnotationsData, ThrowOnError>,
) =>
  (options.client ?? client).get<
    GetBackupJobAnnotationsResponses,
    GetBackupJobAnnotationsErrors,
    ThrowOnError
  >({ url: "/backup/jobs/{name}/annotations", ...options });

/**
 * Create Backup Job Annotation
 *
 * Acknowledge a backup run with a comment and a resolution.
 *
 * This is what replaces the spreadsheet's *Failure Comments* and *Solution*
 * columns — and it improves on them: the author and timestamp are recorded
 * automatically from the signed-in session and the server clock. Anything the
 * request body says about who did this is ignored, which is the difference
 * between an audit trail and a text field.
 *
 * Gated by `SessionDep`, not `AdminDep`: whoever is on the escalation rota
 * acknowledges failures, and that is every signed-in engineer.
 */
export const createBackupJobAnnotation = <ThrowOnError extends boolean = false>(
  options: Options<CreateBackupJobAnnotationData, ThrowOnError>,
) =>
  (options.client ?? client).post<
    CreateBackupJobAnnotationResponses,
    CreateBackupJobAnnotationErrors,
    ThrowOnError
  >({
    url: "/backup/jobs/{name}/annotations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });

/**
 * Backup Coverage
 *
 * Return the unified coverage view across both protection sources.
 *
 * Answers, for every server in the inventory: is it backed up, by what, and
 * when was it last proven? Reports servers protected by nothing, by both
 * (duplicated cost), and Azure protection items whose source resource no
 * longer exists.
 */
export const getBackupCoverage = <ThrowOnError extends boolean = false>(
  options?: Options<GetBackupCoverageData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetBackupCoverageResponses, unknown, ThrowOnError>({
    url: "/backup/coverage",
    ...options,
  });

/**
 * Health
 *
 * Return a simple health status payload.
 */
export const getHealth = <ThrowOnError extends boolean = false>(
  options?: Options<GetHealthData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({
    url: "/health",
    ...options,
  });

/**
 * Auth Logout
 *
 * Sign out — clear the session cookie.
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<LogoutData, ThrowOnError>,
) =>
  (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({
    url: "/auth/logout",
    ...options,
  });

/**
 * Monitoring Overview
 *
 * Return the newest recorded status of every monitored site.
 *
 * Served from the in-process history the background poller maintains, so this
 * is a memory read — it never waits on the monitored sites themselves.
 */
export const getMonitoringOverview = <ThrowOnError extends boolean = false>(
  options?: Options<GetMonitoringOverviewData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMonitoringOverviewResponses, unknown, ThrowOnError>({
    url: "/monitoring/overview",
    ...options,
  });

/**
 * Monitoring Refresh
 *
 * Probe every site now and return the fresh result.
 *
 * Backs the dashboard's "Check now" button, for when waiting out the rest of
 * the poll interval isn't good enough.
 */
export const refreshMonitoring = <ThrowOnError extends boolean = false>(
  options?: Options<RefreshMonitoringData, ThrowOnError>,
) =>
  (options?.client ?? client).post<RefreshMonitoringResponses, unknown, ThrowOnError>({
    url: "/monitoring/refresh",
    ...options,
  });

/**
 * Monitoring History
 *
 * Return per-day availability per site for the last `days` days.
 *
 * Reads the durable rollups, so this survives restarts — unlike the live
 * figures in `/monitoring/overview`, which come from the in-process ring.
 */
export const getMonitoringHistory = <ThrowOnError extends boolean = false>(
  options?: Options<GetMonitoringHistoryData, ThrowOnError>,
) =>
  (options?.client ?? client).get<
    GetMonitoringHistoryResponses,
    GetMonitoringHistoryErrors,
    ThrowOnError
  >({ url: "/monitoring/history", ...options });

/**
 * Auth Me
 *
 * Return the current session's identity.
 */
export const getMe = <ThrowOnError extends boolean = false>(
  options?: Options<GetMeData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMeResponses, unknown, ThrowOnError>({
    url: "/auth/me",
    ...options,
  });
